module.exports = __webpack_public_path__ + "img/tsinghua_anniversary-20160423-3-1024x768.61ee4ea9.jpg";